import { createSelector } from 'reselect';

import { OnboardingContextState } from './onboardingReducer';

export const secretSelector = (state: OnboardingContextState) => {
  return state.secret;
};

export const flowIdSelector = (state: OnboardingContextState) => {
  return state.flowId;
};

export const flowSelector = createSelector(secretSelector, flowIdSelector, (secret, flowId) => ({
  secret,
  id: flowId,
}));

export const onboardingSelector = (state: OnboardingContextState) => {
  return state.onboarding;
};

export const sharedFlowSelector = createSelector(
  (state: OnboardingContextState) => state.onboarding?.sharedFlowId,
  (state: OnboardingContextState) => state.onboarding?.sharedFlowExpiresAt,
  (sharedFlowId, sharedFlowExpiresAt) => ({
    id: sharedFlowId,
    expiresAt: sharedFlowExpiresAt,
  }),
);

export const stepSelector = (state: OnboardingContextState) => {
  return state.step;
};

export const branchesSelector = (state: OnboardingContextState) => {
  return state.branches;
};
